export const MY_LIBRARY_PATH = '/my-library';
export const LEGACY_MY_COLLECTION_PATH = '/my-collection';

/**
 * One permanent hop from the legacy personal-library URL.
 * Returns null for the current path so the redirect cannot loop,
 * and for any other path (including editorial /collections).
 * The search string is copied as-is.
 */
export function resolveLegacyCollectionRedirect(pathname: string, search = ''): string | null {
  const normalized =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  if (normalized !== LEGACY_MY_COLLECTION_PATH) {
    return null;
  }

  const query = search === '' || search.startsWith('?') ? search : `?${search}`;
  return `${MY_LIBRARY_PATH}${query}`;
}
